import React from "react";
import PageHeading from "metabase/components/type/PageHeading";

export const component = PageHeading;

export const description = `Page heading component.`;

export const examples = {
  normal: <PageHeading>Hello World</PageHeading>,
};
